<template>
    <div class="root">
        <div class="title">诺伊成语词典</div>
        <div class="search-root">
            <input v-model="searchString" @keyup.enter="queryIdiom" class="search-input"/>
            <i-button @click="queryIdiom" class="search-button" type="primary">找成语</i-button>
        </div>
        <div class="navigation-root" v-if="showNavigation">
            <div class="navigation-title">使用说明</div>
            <ul class="navigation-tips" style="list-style-type:disc">
                <li>词典共收录了3万余条常用成语</li>
                <li>除了可输入成语查询成语意思外，还可以输入成语的意思来反查询成语哦，如：形容做事认真</li>
                <li>成语反查处于初步测试阶段，可能不是十分准确，还请见谅</li>
            </ul>
        </div>
        <div class="search-result-root" v-if="!showNavigation&&idiomList!=null&&idiomList.length>0">
            <div class="result-item" v-for="(item,index) in idiomList" @click="showIdiomDetail(index)">
                <div class="result-title">{{item.name}}({{item.pinyin}})</div>
                <div class="result-definition">{{item.definition}}</div>
            </div>
        </div>
        <div class="empty-root" v-if="idiomList==null||idiomList.length===0">
            <div class="empty-tip">什么都没找到┓( ´∀` )┏</div>
        </div>
    </div>
</template>

<script>
    import IButton from "view-design/src/components/button/button";

    export default {
        components: { IButton},
        name: "idiom-finder",
        data() {
            return {
                searchString:"",
                showNavigation:true,
                idiomList: [
                    {
                        "name": "黄干黑瘦",
                        "pinyin": "huáng gān hēi shòu",
                        "sugPy": "huangganheishou",
                        "definition": "面容憔悴貌。 "
                    },
                    {
                        "name": "黄干黑廋",
                        "pinyin": "huáng gān hēi sōu",
                        "source": "元·张国宾《罗李郎》第一折:“你恋着红裙翠袖，折倒的你黄干黑廋。”",
                        "sugPy": "huangganheisou",
                        "definition": "面容憔悴的样子。"
                    },
                    {
                        "name": "面目黧黑",
                        "pinyin": "miàn mù lí hēi",
                        "source": "《列子·黄帝》：“年老力弱，面目黧黑。”",
                        "sugPy": "mianmulihei",
                        "synonym": "面目黎黑",
                        "definition": "满脸黑黄色。形容面色憔悴。"
                    }
                ]
            }
        },
        methods:{
            queryIdiom() {
                let that = this;
                if(that.searchString==="")
                {
                    this.$Message.error("请输入");
                    return
                }
                //this.$Loading.start();
                // that.http.post('/',{
                //     'des':that.searchString
                // }).then(res => {
                //     that.$Loading.finish();
                //     that.showNavigation = false;
                //     that.idiomList = res.data;
                //     console.info(res)
                // }).catch(err => {
                //     that.$Loading.error();
                // }).finally(function () {
                // });
            },
            showIdiomDetail(index) {
                let idiom = this.idiomList[index];
                let content = `<p><b>释　义：</b>${idiom.definition}`;
                if(idiom.source!=null) {
                    content += `<p><b>出　处：</b>${ idiom.source}</p>`;
                }
                if(idiom.synonym!=null) {
                    content += `<p><b>近义词：</b>${ idiom.synonym}</p>`;
                }
                if(idiom.antonym!=null) {
                    content += `<p><b>反义词：</b>${ idiom.antonym}</p>`;
                }
                this.$Modal.info({
                    title: idiom.name,
                    content: content
                });
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../styles/index";

    .title {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        padding-top: 16px;
    }
    .root {
        display: flex;
        flex-direction: column;
    }

    .search-result-root {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .search-input {
        display: inline-block;
        width: 100%;
        height: 32px;
        line-height: 1.5;
        padding: 4px 7px;
        font-size: 12px;
        border: 1px solid #dcdee2;
        border-radius: 0 5px 5px 0;
        color: #515a6e;
        background-color: #fff;
        background-image: none;
        position: relative;
        cursor: text;
        transition: border .2s ease-in-out, background .2s ease-in-out, box-shadow .2s ease-in-out;
    }

    .search-input:focus {
        border: 1px solid @primary-color;
        box-shadow: 0 0 2px @primary-color;
        outline: 0 0 8px @primary-color;
    }

    .search-root {
        display: flex;
        flex-direction: row;
        padding: 16px;
    }

    .search-input {
        flex: 1;
        border-radius: 5px 0 0 5px;;
    }

    .search-button {
        border-radius: 0 5px 5px 0;;
    }
    .result-item{
        padding: 16px;
        cursor: pointer;
    }
    .result-title {
        font-size: 14px;
        font-weight: bold;
        color: #000;
    }
    .result-definition{
        font-size: 12px;
        color: #6c6c6c;
    }
    .navigation-root{
        margin: 16px;
    }
    .navigation-title {
        font-size: 16px;
        color: #000;
        font-weight: bold;
    }
    .navigation-tips{
        list-style-type: circle;
    }

    .empty-tip {
        font-size: 18px;
        margin-top: 30%;
        width: 100%;
        text-align: center;
    }

</style>